import React from 'react';
import { ApplicationView, useController } from '@aha-app/mvc';
import SmartRecordsController from '../../controllers/SmartRecordsController';
import styles from './smart-records-panel.module.css';
import terminology from '../../utils/terminology';
import { capitalize } from 'lodash';
import classNames from 'classnames';

const RecordProgress: React.FC = () => {
  const controller = useController(SmartRecordsController);
  const convertedRecordTypes = controller.actionGetConvertedRecordTypes();

  return (
    <div
      className={classNames(
        styles.panelItem,
        styles.panelItemFull,
        styles.progressContainer
      )}
    >
      <aha-loading-dots style={{ color: 'var(--aha-blue-500)' }} />
      <span className={styles.progressHeader}>Conversion in progress</span>
      {convertedRecordTypes.length > 0 && (
        <div className={styles.progressItemsContainer}>
          {convertedRecordTypes.map(recordType => (
            <div key={recordType} className={styles.progressItem}>
              <i
                className='fa-regular fa-check'
                style={{ color: 'var(--theme-light-green-700-dark-green-500)' }}
              />
              <span>{capitalize(terminology(recordType))}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ApplicationView(RecordProgress);
